var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "emd-sidemenu sideMenu-container",
      class: { _open: _vm.isOpen },
    },
    [
      _c(
        "div",
        { ref: "sideMenuBody", staticClass: "emd-sidemenu__body" },
        [_c("app-menu", { attrs: { merchantId: _vm.profile.merchant.id } })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }